import { Injectable } from "@angular/core";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from "@angular/router";
import { Observable, map } from "rxjs";
import { AuthorizationServiceProvider } from "./authorization-service.provider";
import { LogsService } from "../../utils/services/logs.service";

@Injectable({
  providedIn: 'root'
})
/*
Authorization guard
*/
export class AuthGuardService implements CanActivate {

  constructor(
    private authServiceProv: AuthorizationServiceProvider,
    private router: Router,
    private logger: LogsService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.authServiceProv.getCommonRoutines().pipe(
          map(auth => {
            if (auth.isNativeAuthorization() ) {
              this.logger.log(`[AuthGuard] allow native auth url=${state.url}`);
              return true;
            }
            const tokenValid = auth.isTokenValid();
            if (!tokenValid) {
              this.logger.log(`[AuthGuard] deny invalid token url=${state.url} -> startLogin`);
              this.authServiceProv.getOnWebAuthorization().subscribe(
                webAuth => webAuth.startLogin(state.url)
              )
            } else {
              this.logger.log(`[AuthGuard] allow token valid url=${state.url}`);
            }
            return tokenValid;
          })
        );
    }
}
